import React from 'react';
import styles from "../styles.module.scss";

const SearchTypeToggler = ({
    isBulkSearch,
    setIsBulkSearch
}) => {

    const toggleSearchType = (e) => {
        setIsBulkSearch(e.target.innerText === 'Bulk')
    }

    return (
        <div className={`${styles['search-toggler']}`} onClick={toggleSearchType}>
            <button className={`${styles['btn']} ${!isBulkSearch && styles['btn-selected']} no-ml-btn`}>Single</button>
            <button className={`${styles['btn']} ${isBulkSearch && styles['btn-selected']}`}>Bulk</button>
        </div>
    );
}

export default SearchTypeToggler;